<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link
      href="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"
      rel="stylesheet"
      id="bootstrap-css"
    />
    <script src="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/js/bootstrap.min.js"></script>
    <script src="//cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>
    <title>Document</title>
  </head>
  <body>
    <div class="container">
      <div class="row">
        <div class="col col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <h1 style="margin-bottom: 40px">Psychologie Clinique</h1>
        </div>
        <div class="row">
          <p>
            <br />
            Destiné à un <strong>public adulte</strong> (à partir de 18 ans), ce
            service offre un accompagnement spécialisé axé sur
            <strong>l'analyse fonctionnelle du comportement</strong> et
            <strong>le diagnostic personnel</strong>. L'objectif est d'assister
            et de guider la personne dans
            <strong>l'amélioration de sa vie émotionnelle</strong> et de
            <strong>favoriser son développement personnel</strong>. Deux
            services distincts sont mis à disposition : <br /><br />
          </p>
        </div>
        <div class="col col-sm-6 col-md-6 col-lg-6 col-xl-6"></div>
        <hr />
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <br />
          <h4>
            <strong class="strong-blue">1.</strong> Soutien psychologique dans
            le cadre de "Mon soutien psy" (avec ordonnance).
          </h4>
          <p>
            Le cabinet Sinepsy est partenaire de
            <strong>"Mon soutien Psy"</strong> qui vous permet de bénéficier de
            8 séances de 30 minutes remboursées par la Sécurité Sociale ainsi
            que votre Mutuelle.
          </p>
          <a href="/a-propos#sectionEnSavoirPlus" target="_blank"
            ><button id="btn-en-savoir-plus" class="btn btn-primary">
              en savoir plus
            </button></a
          >
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <br />
          <h4>
            <strong class="strong-blue">2.</strong> la psychologie sans
            ordonannce ou mixte (avec et sans ordonannce)
          </h4>
          <p>
            C'est un accompagnement prolongé en terme de quantité et de durée
            des séances qui peut être combiné avec Mon soutien psy. Exemple: M.
            Dupont vient pour une consultation et estime que 30 minutes ne sont
            pas suffisantes pour régler les difficultés qu'il rencontre, il peut
            donc venir pour 1h dont les 30 premières minutes lui seront
            remboursées dans le cadre de Mon soutien psy.
          </p>
          <br /><br />
        </div>
        <hr />
      </div>
      <div class="row">
        <div class="col col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <br /><br />
          <h3>
            Déroulement des séances
            <span style="color: red; font-size: 30px">*</span>
          </h3>
          <br />
          <div class="row">
            <div class="col-md-4">
              <div class="card mb-4">
                <div class="card-header"><h5 class="card-title">1</h5></div>
                <div class="card-body">
                  <p class="card-text">
                    - Rencontrons nous <br />- Discutons de vos attentes <br />-
                    Effectuons les tests appropriés
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card mb-4">
                <div class="card-header">
                  <h5 class="card-title">2</h5>
                </div>
                <div class="card-body">
                  <p class="card-text">
                    - Diagnostic <br />- Echanges autour des résultats
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card mb-4">
                <div class="card-header"><h5 class="card-title">3</h5></div>
                <div class="card-body">
                  <p class="card-text">
                    - Mise en place éventuelle d'un plan d'intervention
                    <br />- Suivi
                  </p>
                </div>
              </div>
            </div>
            <i>
              <span style="color: red; font-size: 30px">*</span>
              Première séance obligatoirement en présentiel, possibilité de
              réaliser les séances suivante en distanciel (visio).
            </i>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <br /><br />
          <h3>Nos tarifs</h3>
          <p>
            <br />

            Première consultation remboursée CPA &nbsp; &nbsp;
            <strong>40€</strong> <br />
            Consultation suivi Remboursée &nbsp; &nbsp;
            <strong>30€</strong> <br />
            Adulte - Première consultation de psychologie (hors 'Mon soutien
            psy') &nbsp; &nbsp;
            <strong>60€</strong> <br />
            Adulte - Consultation de suivi de psychologie (hors 'Mon soutien
            psy') &nbsp; &nbsp;
            <strong>60€</strong> <br />
          </p>
        </div>
      </div>
    </div>
  </body>
</html>
